import { render, staticRenderFns } from "./SwitchPlan.vue?vue&type=template&id=77feea30&scoped=true"
import script from "./SwitchPlan.vue?vue&type=script&lang=js"
export * from "./SwitchPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77feea30",
  null
  
)

export default component.exports